export const navItemClasses = {
  base: 'inline-flex w-full items-center align-middle rounded-lg px-3 py-2 text-sm transition-all duration-200 ease-in-out text-text-secondary! cursor-pointer',
  hover: 'hover:bg-primary/8! hover:text-foreground!',
  active: 'bg-primary/12! hover:bg-primary/16! text-primary! shadow-[inset_3px_0_0_var(--primary)]',
  disabled: 'cursor-not-allowed hover:bg-transparent text-action-disabled!',
};
